// Module 13 - Alerts. axiosClient.baseURL = "/api/v1".
import api from './axiosClient';

const clean = (o = {}) =>
  Object.fromEntries(Object.entries(o).filter(([, v]) => v !== '' && v !== null && v !== undefined));

export const getAlertMeta = async () => (await api.get('/alerts/meta')).data;
export const getAlertSummary = async () => (await api.get('/alerts/summary')).data;

export const listAlertRules = async () => (await api.get('/alerts/rules')).data;
export const createAlertRule = async (body) => (await api.post('/alerts/rules', body)).data;
export const updateAlertRule = async (id, body) => (await api.put(`/alerts/rules/${id}`, body)).data;
export const setAlertRuleEnabled = async (id, enabled) =>
  (await api.post(`/alerts/rules/${id}/${enabled ? 'enable' : 'disable'}`)).data;
export const deleteAlertRule = async (id) => api.delete(`/alerts/rules/${id}`);

export const listAlerts = async (query) => (await api.get('/alerts', { params: clean(query) })).data;
export const acknowledgeAlert = async (id) => (await api.post(`/alerts/${id}/acknowledge`)).data;
export const resolveAlert = async (id) => (await api.post(`/alerts/${id}/resolve`)).data;
export const acknowledgeAllAlerts = async () => (await api.post('/alerts/acknowledge-all')).data;
